import { AxiosResponse } from 'axios';

import { PlaidLinkSuccessParams, PlaidLinkSuccessResponse } from './usePlaidLinkSuccess.interface';

import collectiveApi from 'modules/common/collectiveApi';

const plaidLinkSuccess = async (params: PlaidLinkSuccessParams): Promise<PlaidLinkSuccessResponse> => {
    const { data } = await collectiveApi.post<
        PlaidLinkSuccessResponse,
        AxiosResponse<PlaidLinkSuccessResponse>,
        PlaidLinkSuccessParams
    >('plaid/link-token/plaid_link_success/', params);

    return data;
};

export default plaidLinkSuccess;
